export default "__VITE_ASSET__9d84aaf0__"